declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

export interface DataLayerItem {
  item_id: string
  item_name: string
  affiliation?: string
  coupon?: string
  discount?: number
  index?: number
  item_brand?: string
  item_category?: string
  item_category2?: string
  item_category3?: string
  item_category4?: string
  item_category5?: string
  item_list_id?: string
  item_list_name?: string
  item_variant?: string
  location_id?: string
  price?: number
  quantity?: number
}

export const googlePushProductAddToCart = (ecommerce: { currency: string; value: number; items: DataLayerItem[] }) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce,
    })
  }
}
export const googlePushProductRemoveFromCart = (ecommerce: {
  currency: string
  value: number
  items: DataLayerItem[]
}) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce,
    })
  }
}
export const googlePushViewCart = (ecommerce: { currency: string; value: number; items: DataLayerItem[] }) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'view_cart',
      ecommerce,
    })
  }
}
export const googlePushViewItem = (ecommerce: { currency: string; value: number; items: DataLayerItem[] }) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'view_item',
      ecommerce,
    })
  }
}
export const googlePushViewItemList = (ecommerce: {
  item_list_id?: string
  item_list_name?: string
  items: DataLayerItem[]
}) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'view_item_list',
      ecommerce,
    })
  }
}
export const googlePushProductAddToWishlist = (ecommerce: {
  currency: string
  value: number
  items: DataLayerItem[]
}) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce,
    })
  }
}
export const googlePushLogin = (method: string) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'login',
      ecommerce: { method },
    })
  }
}
export const googlePushSignUp = (method: string) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'sign_up',
      ecommerce: { method },
    })
  }
}
export const googlePushSearch = (searchTerm: string) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'search',
      ecommerce: { search_term: searchTerm },
    })
  }
}
export const googlePushPurchase = (ecommerce: {
  currency: string
  transaction_id: string
  value: number
  coupon?: string
  shipping?: number
  tax?: number
  items: DataLayerItem[]
}) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'purchase',
      ecommerce,
    })
  }
}
export const googlePushRefund = (ecommerce: {
  currency: string
  transaction_id: string
  value: number
  coupon?: string
  shipping?: number
  tax?: number
  items: DataLayerItem[]
}) => {
  const dataLayer = window.dataLayer
  if (dataLayer) {
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      event: 'refund',
      ecommerce,
    })
  }
}
